/**
 * Capacitor platform utilities.
 * Provides helpers for detecting native vs web and accessing Capacitor plugins
 * with graceful web fallbacks.
 */
import { Capacitor } from '@capacitor/core';

/**
 * Returns true when running inside a native iOS/Android shell.
 */
export function isNativePlatform() {
  return Capacitor.isNativePlatform();
}

/**
 * Returns 'ios', 'android', or 'web'.
 */
export function getPlatform() {
  return Capacitor.getPlatform();
}

// True only on the iOS native shell. Used to gate App Store-incompatible UI
// (upgrade prompts, external pricing links, Stripe checkout) — Apple forbids
// in-app payment via non-IAP processors and forbids steering users to the web.
export function isIOS() {
  return Capacitor.getPlatform() === 'ios';
}
